<template>
  <div class="vote">
    <Vote msg="Vote"/>
  </div>
</template>

<script>
  // @ is an alias to /src
  import Vote from '@/components/Vote.vue';

  export default {
    name: 'vote',
    components: {
      Vote,
    },
  };
</script>
